<div class="d-flex justify-content-center align-items-center text-center">
    <span class="spinner-border me-2"></span>
    <span>Loading</span>
</div>